import styled, { css, keyframes } from 'styled-components'
import { rem } from 'utils/common'

const rotate = keyframes`
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`

export const LoaderWrapper = styled.div`
	position: fixed;
	display: none;
	text-align: center;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 999999;

	${(p) =>
		p.isActive &&
		css`
			display: flex;
			background: rgba(255, 255, 255, 0.9);
			justify-content: center;
			align-items: center;
		`}

	${(p) =>
		p.isImageUploader &&
		css`
			position: absolute;
			top: ${rem(0)};
			bottom: ${rem(0)};
			padding: ${rem(10, 0)};
			background: transparent;
		`}
	${(p) =>
		p.isBtnLoader &&
		css`
			position: absolute;
			top: ${rem(0)};
			bottom: ${rem(0)};
			padding: ${rem(10, 0)};
			background: transparent;
		`}
`
export const Wrapper = styled.div`
	display: none;
	position: relative;
	width: 100%;
	${(p) =>
		p.isActive &&
		css`
			display: block;
		`}
`

export const LoaderText = styled.div`
	margin: ${rem(60)} auto;
	font-size: ${rem(10)};
	position: relative;
	text-indent: -9999em;
	border-top: ${rem(3)} solid ${({ theme }) => theme.color.greenFour};
	border-right: ${rem(3)} solid ${({ theme }) => theme.color.greenFour};
	border-bottom: ${rem(3)} solid ${({ theme }) => theme.color.greenFour};
	border-left: ${rem(3)} solid ${({ theme }) => theme.color.primary};
	-webkit-transform: translateZ(0);
	-ms-transform: translateZ(0);
	transform: translateZ(0);
	animation: ${rotate} 1.1s infinite linear;

	${(p) =>
		p.theme.name === 'musto' &&
		css`
			border-top: ${rem(3)} solid
				${({ theme }) => theme.color.tertiatyOne};
			border-right: ${rem(3)} solid
				${({ theme }) => theme.color.tertiatyOne};
			border-bottom: ${rem(3)} solid
				${({ theme }) => theme.color.tertiatyOne}; ;
		`}

	&,
	&:after {
		border-radius: 50%;
		width: ${rem(35)};
		height: ${rem(35)};
	}
`
